import { UserMinus } from "lucide-react";
import { useTranslation, Trans } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface RemoveCollaboratorConfirmationProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  email: string;
  isRemoving?: boolean;
}

export function RemoveCollaboratorConfirmation({
  open,
  onOpenChange,
  onConfirm,
  email,
  isRemoving = false,
}: RemoveCollaboratorConfirmationProps) {
  const { t } = useTranslation("sharing");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[28rem] max-w-[90vw] [&>div>div]:p-6 [&>div>div]:space-y-6">
        <DialogHeader className="space-y-3">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-rose-50">
            <UserMinus className="h-6 w-6 text-destructive" />
          </div>
          <DialogTitle>{t("removeConfirm.title")}</DialogTitle>
          <DialogDescription className="text-sm">
            <Trans
              t={t}
              i18nKey="removeConfirm.description"
              values={{ email }}
              components={{ strong: <strong />, br: <br /> }}
            />
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isRemoving}
          >
            {t("removeConfirm.cancel")}
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isRemoving}
          >
            {t("removeConfirm.remove")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
